const data = {
  "/": {
    en: {
      title: "Dental Bot 3D — training and motivational system for dental clinics",
      desc: "Dental application Dental Bot 3D reduces the time of consultation, increases sales  treatment plans, motivates patients to choose the best methods of treatmen.",
      keys: "dental bot 3D, dental bot 3D system, dental application dental bot 3D",
      url: "/",
      img: require("./metaListAssets/Dental_Bot_Home_Page_image.jpg").default,
    },
    ru: {
      title: "Dental Bot 3D — обучающая и мотивационная система для стоматологических клиник",
      desc: "Стоматологическое приложение Dental Bot 3D сокращает время консультации, повышает продажи планов лечения, мотивирует пациентов выбирать оптимальные методы лечения.",
      keys: "dental bot 3D, система dental bot 3D, стоматологическое приложение dental bot 3D, мотивация пациентов",
      url: "/",
      img: require("./metaListAssets/Dental_Bot_Home_Page_image.jpg").default,
    },
    ua: {
      title: "Dental Bot 3D — навчальна та мотиваційна система для стоматологічних клінік",
      desc: "Стоматологічний додаток Dental Bot 3D скорочує час консультації, підвищує продаж планів лікування, мотивує пацієнтів вибирати оптимальні методи лікування",
      keys: "dental bot 3D, система dental bot 3D, стоматологічний додаток dental bot 3D, мотивація пацієнтів",
      url: "/",
      img: require("./metaListAssets/Dental_Bot_Home_Page_image.jpg").default,
    },
  },

  "/articles": {
    en: {
      title: "Dental articles and educational content",
      desc: "This page contains dental articles related to Dental Bot 3D - a system that motivates patients and visualizes clinical cases in dentistry",
      keys: "dental articles, clinical cases in dentistry, digital technologies in dentistry, dentistry of the future, dental application for patients, modern dental clinic, desktop application",
      url: "/articles",
      img: require("./metaListAssets/articles.jpg").default,
    },
    ru: {
      title: "Стоматологические статьи и образовательный контент",
      desc: "Страница содержит стоматологические статьи, связанные с Dental Bot 3D — системой, мотивирующей пациентов и визуализирующей клинические случаи в стоматологии",
      keys: "стоматологические статьи, клинические случаи в стоматологии, цифровые технологии в стоматологии, стоматологии будущего, стоматологическое приложение для пациентов, современная стоматологическая клиника, десктоп приложение",
      url: "/articles",
      img: require("./metaListAssets/articles.jpg").default,
    },
    ua: {
      title: "Стоматологічні статті та освітній контент",
      desc: "Сторінка містить стоматологічні статті, пов'язані з Dental Bot 3D - системою, мотивуючою пацієнтів і візуалізуючою клінічні випадки в стоматології",
      keys: "стоматологічні статті, клінічні випадки в стоматології, цифрові технології в стоматології, стоматологічний додаток для пацієнтів, сучасна стоматологічна клініка, десктоп додаток, онлайн презентація планів лікування, фінансові плани лікування, типи конструкцій на імплантатах, демонстрація типів фіксації протезів",
      url: "/articles",
      img: require("./metaListAssets/articles.jpg").default,
    },
  },

  "/preview": {
    en: {
      title: "Link to view dental treatment plan",
      desc: "Link to 3D patient card to showcase the dental treatment plan ",
      keys: "3D patient card",
      url: "/preview",
      img: require("./metaListAssets/preview.jpg").default,
    },
    ru: {
      title: "Ссылка для просмотра стоматологического плана лечения",
      desc: "Ссылка на 3D карту пациента для демонстрации стоматологического плана лечения",
      keys: "3D карта пациента",
      url: "/preview",
      img: require("./metaListAssets/preview.jpg").default,
    },
    ua: {
      title: "Посилання для перегляду стоматологічного плану лікування",
      desc: "Посилання на 3D карту пацієнта для демонстрації стоматологічного плану лікування.",
      keys: "3D карта пацієнта",
      url: "/preview",
      img: require("./metaListAssets/preview.jpg").default,
    },
  },

  "/videos": {
    en: {
      title: "Video review of the program Dental Bot 3D",
      desc: "Overview videos of the program interface. Use them to familiarize yourself with the functions of the application.",
      keys: "Dental Bot 3D overview videos",
      url: "/videos",
      img: require("./metaListAssets/preview.jpg").default,
    },
    ru: {
      title: "Видеообзор программы Dental Bot 3D",
      desc: "Обзорные видео интерфейса программы. Используйте их, чтобы ознакомиться с функциями приложения.",
      keys: "обзорные видеоролики Dental Bot 3D",
      url: "/videos",
      img: require("./metaListAssets/preview.jpg").default,
    },
    ua: {
      title: "Відеоогляд програми Dental Bot 3D",
      desc: "Оглядові відео інтерфейсу програми. Використовуйте їх, щоб ознайомитися з функціями програми.",
      keys: "оглядові відеоролики Dental Bot 3D",
      url: "/videos",
      img: require("./metaListAssets/preview.jpg").default,
    },
  },

  "/3D-clinical-model": {
    en: {
      title: "3D Clinical Model",
      desc: "Digital spatial model of human teeth designed to demonstrate clinical cases.",
      keys: "3D model, implantation, prosthetics, veneers, veneering, crowns",
      url: "/3D-clinical-model",
      img: require("./metaListAssets/3d_clinical_model.jpg").default,
    },
    ru: {
      title: "3D типодонт",
      desc: "Цифроавя пространственная модель зубов человека, предназначенная для демонстрации клинических случаев.",
      keys: "3D модель, имплантация, протезирование, виниры, виниринг, коронки",
      url: "/3D-clinical-model",
      img: require("./metaListAssets/3d_clinical_model.jpg").default,
    },
    ua: {
      title: "3D типодонт",
      desc: "Ціфроавя просторова модель зубів людини, призначена для демонстрації клінічних випадків.",
      keys: "3D модель, імплантація, протезування, вініри, вінірінг, коронки",
      url: "/3D-clinical-model",
      img: require("./metaListAssets/3d_clinical_model.jpg").default,
    },
  },
};

export default data;
